module.exports = __webpack_public_path__ + "static/img/20.b6f9a43.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/20.jpg
// module id = 0nTw
// module chunks = 0